import React from 'react';
import TitleMain from "../../components/Title/TitleMain";

export default function Cgu({}) {
    const text = {
        title: "Conditions",
        sections: [
            {
                title: "PREAMBULE",
                content: [
                    {type: "space"},
                    "La plateforme Atwork Elancia propose la mise en place, la planification et la gestion d’un programme Sport Santé Bien-être dans votre entreprise. Il peut s’agir d’animation de groupe ou de rendez-vous individuels. Les activités physiques et sportives nécessitent que vous vous posiez quelques questions avant de les pratiquer afin de dépister d’éventuels risques. Par ailleurs les activités porteront leurs effets bénéfiques dans l’assiduité et la régularité des séances.",
                    {type: "space"},
                    {type: "space"},
                    {type: "space"},
                ]
            },
            {
                title: "INSCRIPTION- SANTE",
                content: [
                    {type: "space"},
                    "Dans le cadre de pratiques d’activité physique et sportive, vous devez vous poser les questions ci-dessous nécessaires au dépistage d’éventuels risques à la pratique d’activités physiques et sportives ;",
                    {type: "space"},
                    {type: "space"},
                    "Etes-vous un homme de plus de 40 ans ? Une femme de plus de 50 ans ?",
                    {type: "space"},
                    {type: "space"},
                    "Avez-vous déjà ressenti des douleurs dans la poitrine ?",
                    {type: "space"},
                    {type: "space"},
                    "Avez-vous déjà présenté des malaises où pertes de connaissance ?",
                    {type: "space"},
                    {type: "space"},
                    "Y a-t-il eu une mort subite dans votre famille ?",
                    {type: "space"},
                    {type: "space"},
                    "Fumez-vous ? Êtes-vous diabétique ?",
                    {type: "space"},
                    {type: "space"},
                    "Des médicaments vous sont-ils prescrits pour contrôler votre tension ou un problème cardio-vasculaire ?",
                    {type: "space"},
                    {type: "space"},
                    "Dans le cas d’une réponse positive à une seule des questions ci-dessus Elancia vous recommande de consulter un médecin et de déposer sur la plateforme un certificat médical de non contre-indication à la pratique du sport avant la 1ère séance. Elancia conseille de renouveler cette démarche chaque année. La remise d’un tel certificat n’étant pas une obligation légale, est laissée à votre appréciation. En conséquence, vous déchargez Elancia de toute responsabilité quant à la survenue d’un accident lié à mon état de santé.",
                    {type: "space"},
                    {type: "space"},
                    "Vous renseignez sur la plateforme les informations vous concernant, nom, prénom, sexe, mail, téléphone, date de naissance et choisissez votre mot de passe et déposez le cas échéant votre avis de non contre-indication à l’activité physique et sportive.",
                    {type: "space"},
                    {type: "space"},
                    {type: "space"},
                ]
            },
            {
                title: "UTILISATION DE LA PLATEFORME",
                content: [
                    {type: "space"},
                    "Vous accédez à votre compte en vous connectant sur la plateforme Elancia Atwork atwork.elancia.fr, en renseignant votre identifiant et mot de passe qui vous donneront accès à votre compte.",
                    {type: "space"},
                    {type: "space"},
                    {type: "space"},
                ]
            },
            {
                title: "ASSIDUITE - ETHIQUE",
                content: [
                    {type: "space"},
                    "C’est dans l’assiduité et la régularité que la pratique d’activité bien-être et/ou d’activités physiques et sportives procurent tous leurs bienfaits dans sur le corps que sur l’esprit.",
                    {type: "space"},
                    {type: "space"},

                    "La plateforme Atwork vous permet néanmoins de pouvoir annuler une inscription en cas d’impossibilité ou de volonté d’arrêter une activité.",
                    {type: "space"},
                    {type: "space"},

                    "Il est important ",
                    {type: "bold", text: "en cas d’impossibilité de participer "},
                    " à une séance de ",
                    {type: "bold", text: "le signaler en vous désinscrivant "},
                    "afin de pouvoir laisser la place à un(e) de vos collègues de travail qui serait en liste d’attente.",
                    {type: "space"},
                    {type: "space"},
                    {type: "space"},

                ]
            },
            {
                title: "INFORMATIQUE ET LIBERTE",
                content: [
                    {type: "space"},
                    "Conformément à la Loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés les informations recueillies sur le formulaire d’inscription sont enregistrées dans un fichier informatisé par ",
                    {type: "bold", text: "Elancia Atwork"},
                    " pour ",
                    {type: "bold", text: "la planification, gestion et reporting de programme de sport santé bien-être dans votre entreprise."},
                    {type: "space"},
                    {type: "space"},
                    "Conformément à la loi ",
                    {type: "link", text: "« informatique et libertés »", url: "https://www.cnil.fr/fr/le-cadre-national/la-loi-informatique-et-libertes"},
                    ", vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant ",
                    {type: "bold", text: "Elancia Atwork"},
                    " par mail à l’adresse suivante ",
                    {type: "link", text: "atwork@elancia.fr", url: "mailto:atwork@elancia.fr"},
                    {type: "space"},
                    {type: "space"},
                    {type: "bold", text: " Elancia vous souhaite de passer d’agréables moments de détente et découverte en sortant des sentiers battus au travers de moments santé, d’expériences bien-être et de découvertes d’activités physiques."},
                    {type: "space"},
                    {type: "space"},
                    "N’hésitez pas à faire vos retours à ",
                    {type: "link", text: "atwork@elancia.fr", url: "mailto:atwork@elancia.fr"},
                    {type: "space"},
                    {type: "space"},
                    {type: "space"},
                ]
            }
        ]
    }

    const RenderContent = ({ content }) => {
        return content.map((item, index) => {
            if (typeof item === 'string') {
                return <span key={index}>{item}</span>;
            }

            if (item.type === 'space') {
                return <br key={index} />;
            }

            if (item.type === 'bold') {
                return <strong key={index}>{item.text}</strong>;
            }

            if (item.type === 'link') {
                return (
                    <a key={index} href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.text}
                    </a>
                );
            }

            return null;
        });
    };

    const ContentSections = ({ sections }) => {
        return (
            <div>
                {sections.map((section, index) => (
                    <div key={index} className="section">
                        <h2>{section.title}</h2>
                        <p>
                            <RenderContent content={section.content} />
                        </p>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="content">
            <TitleMain text={text.title} />

            <div>
                <ContentSections sections={text.sections} />
            </div>
        </div>
    )
}

